import { parseISO } from 'date-fns';

/**
 * Normalize a given value into a Date object. This function will accept a string, a Date
 * or a number and return Date representation of the value.
 *
 * @param value - The value to normalize.
 * @returns A normalized date object.
 */
export default function normalizeDate(value?: string | Date | number) {
  if (typeof value === 'number') {
    return new Date(value); // the reverse is Date.prototype.getTime()
  }

  if (!value) {
    return new Date();
  }

  if (typeof value === 'string') {
    return parseISO(value);
  }

  return value;
}
